import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";

export const TOOL_PANELS = {
  columns: "columns",
  filters: "filters",
  saveConfiguration: "save_configuration"
};

export const entryType = {
  cluster: "CLUSTER",
  standaloneEquipment: "STANDALONE-EQUIPMENT",
  clusterSubequipment: "CLUSTER-SUBEQUIPMENT"
};

export const MY_LAB = "My lab";

export const SOP_RT = "SOP RT0020";

export const PREDEFINED_FILTER_NAME = "Predefined filter";

export const SELECT_PREDEFINED_FILTER_NAME = "Select predefined filter";

export const PREDEFINED_COLUMN_NAME = "Predefined column";

export const SELECT_PREDEFINED_COLUMN_NAME = "Select predefined column";

export const filterKeyMapping = {
  serialNumber: DATA_MODEL_TABLE?.serialNumber?.key,
  materialNumber: DATA_MODEL_TABLE?.materialNumber?.key,
  equipmentId: DATA_MODEL_TABLE?.equipmentId?.key,
  tags: DATA_MODEL_TABLE?.tags?.key,
  linkedInstance: DATA_MODEL_TABLE?.linkedInstance?.key,
  site: DATA_MODEL_TABLE?.siteName?.key,
  group: DATA_MODEL_TABLE?.belongingToGroup?.key,
  manufacturer: DATA_MODEL_TABLE?.manufacturer?.key,
  category: DATA_MODEL_TABLE?.equipmentCategory?.key,
  responsiblePerson: DATA_MODEL_TABLE?.responsiblePerson?.key,
  dateOfNextMaintanance: DATA_MODEL_TABLE?.dateOfNextMaintanance?.key,
  status: DATA_MODEL_TABLE?.status?.key,
  dateFrom: "dateFrom",
  dateTo: "dateTo",
  inventoryIds: "_id"
};

export const GXPemptyInstrumentsOptions = {
  gxpRelevant: [
    { key: "No", value: "No" },
    { key: "Yes", value: "Yes" }
  ],
  qualificationStatus: [
    { key: "NA", value: "NA" },
    { key: "NOT_QUALIFIED", value: "Not qualified" },
    { key: "QUALIFIED", value: "Qualified" }
  ],
  controlledEquipmentStatus: [
    { key: "CALIBRATED", value: "Calibrated" },
    { key: "NA", value: "NA" },
    { key: "NOT_CALIBRATED", value: "Not calibrated" }
  ],
  dateOfNextMaintanance: null,
  dateOfLastMaintanance: null
};

export const mappedFilterValues = {
  linkedInstance: [
    {
      key: "Corelab SAP",
      value: "CLP"
    },
    {
      key: "RMD SAP",
      value: "Molecular"
    },
    {
      key: "None",
      value: "None"
    }
  ],
  gxpRelevant: [...GXPemptyInstrumentsOptions?.gxpRelevant],
  qualificationStatus: [...GXPemptyInstrumentsOptions?.qualificationStatus],
  controlledEquipmentStatus: [...GXPemptyInstrumentsOptions?.controlledEquipmentStatus]
};

export const dropDownSelectionSource = {
  agGridFilter: "AG_GRID_FILTER",
  agGridColumn: "AG_GRID_COLUMN",
  nonAgGridFilter: "NON_AG_GRID_FILTER",
  nonAgGridColumn: "NON_AG_GRID_COLUMN"
};
